import React, { ReactNode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import About from './pages/About';
import Blog from './pages/Blog';
import Home from './pages/Home';
import DemoDock from './pages/DemoDock/DemoDock';
import DemoDockSkus from './pages/DemoDock/DemoDockSkus';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import WC26 from './pages/WC26';
import TestBlog from './pages/TestBlog';
import DemoDockLoginSignup from './pages/DemoDock/DemoDockLoginSignup';
import BrainPocket from './pages/BrainPocket/BrainPocket';
import WheelOfChores from './pages/WheelOfChores/WheelOfChores';
import FlowPetRPG from './pages/FlowPetRPG/FlowPetRPG';
import MealPlanner from './pages/MealPlanner/MealPlanner';
import ProjectCaseStudy from './pages/ProjectCaseStudy';
import ChloromanceTracker from './pages/ChloromanceTracker/ChloromanceTracker';
import PrivacyPolicy from './pages/ChloromanceTracker/PrivacyPolicy';
import ChloromanceAuthGate from './components/Chloromance/ChloromanceAuthGate';
import LocalizationControlPlane from './pages/LocalizationControlPlane/LocalizationControlPlane';
import Wardrobe from './pages/Wardrobe/Wardrobe';
import FitHappensAuthGate from './components/FitHappens/FitHappensAuthGate';
import ScrunchDemo from './pages/ScrunchDemo/ScrunchDemo';
import ScrunchExplainer from './pages/ScrunchDemo/ScrunchExplainer';

export function AppRouteViews() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/test" element={<TestBlog />} />
      <Route path="/blog/demodock-architecture" element={<ProjectCaseStudy project="demodock" />} />
      <Route path="/blog/brainpocket-architecture" element={<ProjectCaseStudy project="brainpocket" />} />
      <Route path="/blog/wheel-of-chores-architecture" element={<ProjectCaseStudy project="wheel-of-chores" />} />
      <Route path="/blog/chloromance-tracker-architecture" element={<ProjectCaseStudy project="chloromance-tracker" />} />
      <Route path="/blog/flow-pet-rpg-architecture" element={<ProjectCaseStudy project="flow-pet-rpg" />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/demodock/skus" element={<DemoDockSkus />} />
      <Route path="/projects/demodock/login-signup" element={<DemoDockLoginSignup />} />
      <Route path="/projects/demodock" element={<DemoDock />} />
      <Route path="/projects/brainpocket" element={<BrainPocket />} />
      <Route path="/projects/wheel-of-chores" element={<WheelOfChores />} />
      <Route path="/projects/flow-pet-rpg" element={<FlowPetRPG />} />
      <Route path="/projects/meal-planner" element={<MealPlanner />} />
      <Route path="/projects/localization-control-plane" element={<LocalizationControlPlane />} />
      <Route path="/scrunch-demo" element={<ScrunchDemo />} />
      <Route path="/scrunch-demo/explainer" element={<ScrunchExplainer />} />
      <Route path="/projects/wardrobe" element={<FitHappensAuthGate>{(user, sessionBar) => <Wardrobe userId={user.id} sessionBar={sessionBar} />}</FitHappensAuthGate>} />
      <Route
        path="/projects/chloromance-tracker"
        element={(
          <ChloromanceAuthGate renderSessionBarInChildren>
            {(user, openPrivacy, sessionBar) => (
              <ChloromanceTracker userId={user.id} onOpenPrivacy={openPrivacy} sessionBar={sessionBar} allowMockUpgrade />
            )}
          </ChloromanceAuthGate>
        )}
      />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/about" element={<About />} />
      <Route path="/resume" element={<Resume />} />
      <Route path="/wc26" element={<WC26 />} />
    </Routes>
  );
}

type AppRoutesProps = {
  children?: ReactNode;
};

function AppRoutes({ children }: AppRoutesProps) {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      {children ?? <AppRouteViews />}
    </BrowserRouter>
  );
}

export default AppRoutes;
